export default "//#pageHeader {\n//  position: relative;\n//}\n//\n//#pageHeader {\n//  /*border: 3px solid forestgreen !important;*/\n//}\n//\n//#pageHeader:after {\n//  content:    'Hi from VIP!';\n//  position:   absolute;\n//  bottom:     -2em;\n//  color:      black;\n//  font-size:  14px;\n//  background: white;\n//  border:     thin solid black;\n//  border-radius:5px;\n//  padding:    .5em;\n//}\n\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader/dist/cjs.js!./src/stores/catalog/flexLayout/flexComponents/content-panels/C8Overrides.css
// module id = 1121
// module chunks = 10